module.exports = __webpack_public_path__ + "static/logo-5e0a85692decf9c4242e6456b455ba12.png";